{
  "#PMS_STATUSABFRAGE": {
    "ABTEILUNGEN": {
      "PERSONEN_ANWESEND": "Personen anwesend",
      "PERSONEN": "x/{{count}} Personen anwesend"
    },
    "ABTEILUNG": {
      "FILTER": {
        "ANWESEND": "Anwesend",
        "ABWESEND": "Abwesend"
      }
    },
    "MITARBEITER_DETAIL": {
      "KONTAKTDATEN": {
        "TITEL": "KONTAKTDATEN"
      },
      "DIENSTPLAN": {
        "TITEL": "DIENSTPLAN"
      },
      "STEMPEL": {
        "TITEL": "STEMPEL",
        "KOMMT_HEADER": "Kommt",
        "GEHT_HEADER": "Geht",
        "KOMMT_GEHT": "K/G:",
        "KOMMT": "Kommt",
        "GEHT": "Geht",
        "TAG": "Tag:",
        "STEMPEL": "Stempel:",
        "CODE": "Code:",
        "UEBERNAHMEDATUM": "Übernahmedatum:",
        "ANWENDER": "Anwender:",
        "GERAET": "Gerät:",
        "ERFASSUNGSDATUM": "Erfassungsdatum:",
        "BEMERKUNG": "Bemerkung:",
        "TAETIGKEIT": "Tätigkeit:",
        "KST": "Kst:",
        "HERKUNFT": "Herkunft:",
        "GELOESCHT": "Gelöscht:"
      },
      "TERMINE": {
        "TITEL": "TERMINE"
      },
      "ISTZEIT": {
        "TITEL": "ISTZEIT"
      },
      "NICHT_ERFASST": "Nicht erfasst"
    }
  }
}
